function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, Array, JSON, Object, String, editWarningModalOpen, isBookmarkSelectorOpen, isDescriptionTruncated) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['created-by-icon'] = function(creatorId, creatorName, creatorEmail, isStaff) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((creatorName || creatorEmail) ? ((function() {
          var __jade_nodes = [];
          const isMixpanel = creatorEmail && creatorEmail.endsWith(`@mixpanel.com`);;
          const isStaffAvatar = isMixpanel && !isStaff;;
          const name = isStaffAvatar ? `the Mixpanel Team` : creatorName;;
          const id = isStaffAvatar ? null : creatorId;;
          __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              id,
              name,
              'is-staff-avatar': isStaffAvatar,
              'tooltip-text': `Created by ${name}`,
              'tooltip-placement': `bottom`,
              size: `medium`,
            }),
            "class": {
              'created-by-icon': true
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['recaptcha'] = function(recaptchaKey) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": 'g-recapcha',
          "attrs": __vjadeStringifyAttrsIfObj({
            id: `recaptcha`,
            class: `g-recaptcha `,
            'data-sitekey': recaptchaKey,
            'data-size': `invisible`,
            'data-error-callback': `handleRecaptchaError`,
            'data-callback': `handleRecaptchaResponse`,
          }),
          "class": {
            'recaptcha': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-query-report-header': true
        },
      }, (function() {
        var __jade_nodes = [];
        const creatorId = $attr(`selected-bookmark-user-id`);;
        const creatorName = $attr(`selected-bookmark-user-name`);;
        const creatorEmail = $attr(`selected-bookmark-user-email`);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-report-header-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          const canEdit = $attr(`can-write`) && $attr(`can-save`);;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `reportTitleButton`,
            }),
            "on": {
              click: canEdit && $helpers.editReportClicked
            },
            "class": Object.assign({}, {
              'unsaved-bookmark': !$helpers.hasSelectedEntity(),
              'editable-bookmark': canEdit,
            }, {
              'mp-query-report-header-title-text': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`selected-bookmark-name`) || $attr(`empty-bookmark-name`));
            __jade_nodes = __jade_nodes.concat((canEdit) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `edit`,
                  theme: `tertiary`,
                  elref: `reportEditButton`,
                }),
                "on": {
                  click: $helpers.editReportClicked
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          const computedAt = $attr(`computed-at`);;
          const samplingNotice = $helpers.getSamplingNotice();;
          const description = $attr(`selected-bookmark-description`);;
          const needsTruncation = description && description.length > 100;;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-report-header-title-subtext': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((description) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: needsTruncation && $helpers.toggleDescriptionTruncation
                },
                "class": Object.assign({}, {
                  'mp-query-report-header-description-truncated': isDescriptionTruncated
                }, {
                  'mp-query-report-header-description': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-query-report-header-description-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(description);
                  __jade_nodes = __jade_nodes.concat((!isDescriptionTruncated) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'mp-query-report-header-description-less': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("less");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat((needsTruncation && isDescriptionTruncated) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-query-report-header-description-more': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("more");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-report-header-metadata': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((computedAt) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-query-report-header-last-updated': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-last-updated", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'is-compact': false,
                      'last-refresh-date': computedAt,
                      'preface-text': `Updated`,
                    }),
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((samplingNotice) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-query-report-header-sampling-notice': true
                  },
                }, [__vjadeSafeCode(samplingNotice)]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-report-header-actions': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-control-bar", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes({
              'theme': `tertiary`,
              'controls': $helpers.getHeaderActionItems(),
              'overflow-controls': $helpers.getHeaderActionOverflowItems(),
            })),
            "on": {
              select: $helpers.onHeaderActionClick
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                slot: `createdBy`,
                class: 'created-by'
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((creatorId) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    id: creatorId,
                    name: creatorName,
                    email: creatorEmail,
                    size: $helpers.IconSizeType.Medium,
                    'label-prefix': `Created by`,
                  }),
                  "class": {
                    'created-by-icon': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-sharing-status-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `reportShareButton`,
                disabled: !$helpers.isShareButtonEnabled(),
                id: $attr(`selected-bookmark-id`),
                'is-select': true,
                'project-id': $attr(`project-id`),
                theme: `primary`,
                'tooltip-text': $helpers.getShareTooltipText(),
                type: $helpers.getSharableEntityType(),
                slot: `sharing`,
              }),
              "on": {
                share: $helpers.isShareButtonEnabled() ? $helpers.handleSharingStatusButtonClick : null,
              },
            })); /*  mirror item slots down the DOM tree */
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($helpers.getHeaderActionItemsSlots());
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("slot", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        name: item.slot,
                        slot: item.slot
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var item = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("slot", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            name: item.slot,
                            slot: item.slot
                          }),
                        }));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  saved reports drawer */
        __jade_nodes = __jade_nodes.concat((isBookmarkSelectorOpen) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-load-entity-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": __vjadeStringifyAttrsIfObj({
              open: true,
              'entities-loading': $attr(`entities-loading`),
              'display-context': $attr(`display-context`),
              'modal-title': `Open Report`,
              'track-name': $attr(`track-name`),
              'empty-message': 'You don\'t have any saved reports yet.',
              'project-id': $attr(`project-id`),
              'user-id': $attr(`user-id`),
              'workspace-id': $attr(`workspace-id`),
            }),
            "on": {
              close: $helpers.closeBookmarkSelector,
              select: $helpers.bookmarkSelected,
              track: $helpers.propagateEvent,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined); /*  TODO @evnp - replace modal jade with "promisified" modal code, e.g. https://github.com/mixpanel/analytics/blob/master/iron/common/widgets/chrome/chrome-header/index.ts#L759 */
        /*  save new report modal */
        __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
          "hook": {
            remove: $hooks.delayedAttrRemove(`open`, false)
          },
          "attrs": __vjadeStringifyAttrsIfObj($helpers.buildCreateEntityModalAttrs()),
          "on": {
            cancel: (ev) => $helpers.closeSaveModal(ev),
            save: $helpers.submitSaveModal,
            saveAndShare: $helpers.submitSaveModal,
          },
        })); /*  update existing report warning modal - warns when changes will affect dashboards or alerts */
        __jade_nodes = __jade_nodes.concat(h("mp-confirm", {
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: `confirm`,
            'confirm-button-label': 'Save',
            open: editWarningModalOpen,
          }),
          "on": {
            submit: $helpers.editWarningModalSubmit,
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Save Report");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-description': true
              },
            }, [__vjadeSafeCode($helpers.getEditWarning())]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "editWarningModalOpen" in locals ? locals.editWarningModalOpen : typeof editWarningModalOpen !== "undefined" ? editWarningModalOpen : undefined, "isBookmarkSelectorOpen" in locals ? locals.isBookmarkSelectorOpen : typeof isBookmarkSelectorOpen !== "undefined" ? isBookmarkSelectorOpen : undefined, "isDescriptionTruncated" in locals ? locals.isDescriptionTruncated : typeof isDescriptionTruncated !== "undefined" ? isDescriptionTruncated : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;